import { render, staticRenderFns } from "./formThesis.vue?vue&type=template&id=f8e97970&scoped=true&"
import script from "./formThesis.vue?vue&type=script&lang=js&"
export * from "./formThesis.vue?vue&type=script&lang=js&"
import style0 from "./formThesis.vue?vue&type=style&index=0&id=f8e97970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e97970",
  null
  
)

export default component.exports